import { CanDeactivateFn } from '@angular/router'
import { inject } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { Observable, map } from 'rxjs'
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component'
import { TranslateService } from '@ngx-translate/core'

export type DeactivateDialogData = {
  titleKey: string
  descriptionKey: string
  confirmLabelKey: string
  cancelLabelKey: string
}

export type ComponentWithUnsavedChanges = {
  hasUnsavedChanges: boolean
  getDeactivateDialogData?: () => DeactivateDialogData | null
}

export const unsavedChangesGuard: CanDeactivateFn<ComponentWithUnsavedChanges> = (component) => {
  if (!component.hasUnsavedChanges) {
    return true
  }

  const dialog = inject(MatDialog)
  const translateService = inject(TranslateService)

  const customDialogData = component.getDeactivateDialogData?.()

  const dialogRef = dialog.open(ConfirmDialogComponent, {
    data: {
      title: translateService.instant(customDialogData?.titleKey ?? 'TEMPLATES.UNSAVED_CHANGES_DIALOG.TITLE'),
      description: translateService.instant(customDialogData?.descriptionKey ?? 'TEMPLATES.UNSAVED_CHANGES_DIALOG.DESCRIPTION'),
      confirmLabel: translateService.instant(customDialogData?.confirmLabelKey ?? 'TEMPLATES.UNSAVED_CHANGES_DIALOG.LEAVE'),
      cancelLabel: translateService.instant(customDialogData?.cancelLabelKey ?? 'TEMPLATES.UNSAVED_CHANGES_DIALOG.STAY'),
    },
  })

  return dialogRef.afterClosed().pipe(map((confirmed) => confirmed === true)) as Observable<boolean>
}
